import DashboardApi from './_dashboardApi';
import httpClient from '@/apis/base/httpclient';
class DashboardBudgetSituationAPI extends DashboardApi {
  constructor() {
    super();
  }
  controllerName = 'Dashboards';

  /**
   * Lấy dữ liệu combobox biểu đồ
   * vcdoan 22.06.2023
   */
  GetBudgetSourceComboBudgetSituation() {
    let request = {
      url: this.getAPIUrl() + '/DataChartArises',
    };
    return httpClient.postAsync(request);
  }

  /**
 * Lấy dữ liệu combobox load paging
 */
  getComboboxPaging(payload) {
    let request = {
      url: this.getAPIUrl() + '/DataChartArises',
      data: payload
    };
    return httpClient.postAsync(request);
  }

  /**
   * Lấy dữ liệu cho biểu đồ 
   * vcdoan 22.06.2023
   */
  async getChartData(param) {
    let request = {
      url: this.getAPIUrl() + '/DataChart',
      data: param,
    };
    let data = await httpClient.postAsync(request)
    if (data.AdvanceArises || data.AdvanceSurplus || data.ActualArises || data.ActualSurplus) {

      return [{
        name: 'Số tạm ứng',
        data: [data.AdvanceArises, data.AdvanceSurplus]
      }, {
        name: 'Số thực chi',
        data: [data.ActualArises, data.ActualSurplus]
      }];
    } else {
      return []
    }
  }
  /**
   * Lấy dữ liệu biểu đồ phục vụ misa ava
   * NBTIN 23.05.2024
   */
  async getChartDataMisaAva(param){
    let request = {
      url: this.getAPIUrl() + '/DataChartMisaAva',
      data: param,
    };
    return httpClient.postAsync(request)
  }
}

export default new DashboardBudgetSituationAPI();
